import Dbm from "dbm";
import Website from "../../../index.js";

export default class SwitchableGraphics extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        let animationLayer = Dbm.flow.externalObject(new PIXI.Container());
        this.item.setValue("animationLayer", animationLayer.item);
        animationLayer.object.scale = 0;
        animationLayer.addProperty("scale", 0);
        animationLayer.object.alpha = 0;
        animationLayer.addProperty("alpha", 0);
        
        container.addChild(animationLayer.object);

        let pivotLayer = new PIXI.Container();
        this.item.setValue("pivotLayer", pivotLayer);
        animationLayer.object.addChild(pivotLayer);
    }

    setup(aWidth = 40, aLeft = true) {
        if(aLeft) {
            let background = Website.game.get9Sliced("objects/speech", "left", 0, 19, 3, 3, 10);
            this.item.setValue("background", background);
            this.item.pivotLayer.addChild(background);
            background.width = aWidth;

            let text = Dbm.getRepositoryItem("game").controller.getText("...", 10, 0x000000, {wordWrap: true, wordWrapWidth: aWidth-2*5, lineHeight: 15});
            this.item.setValue("text", text);
            text.position.set(3, 3);
            this.item.pivotLayer.addChild(text);

            this.item.pivotLayer.position.set(-12, -27);
        }
        else {
            let background = Website.game.get9Sliced("objects/speech", "right", 0, 3, 3, 19, 10);
            this.item.setValue("background", background);
            this.item.pivotLayer.addChild(background);
            background.width = aWidth;

            let text = Dbm.getRepositoryItem("game").controller.getText("...", 10, 0x000000, {wordWrap: true, wordWrapWidth: aWidth-2*5, lineHeight: 15});
            this.item.setValue("text", text);
            text.position.set(3, 3);
            this.item.pivotLayer.addChild(text);

            this.item.pivotLayer.position.set(12-aWidth, -27);
        }
    }

    setText(aText) {
        this.item.text.text = aText;
        this.item.background.height = this.item.text.height+3+9;
        this.item.pivotLayer.position.y = -1*this.item.background.height;

        return this;
    }

    show(aDelay = 0) {
        this.item.animationLayer.properties.alpha.animateValue(1, 0.3, aDelay);
        this.item.animationLayer.properties.scale.animateValue(1, 0.3, aDelay);
    }

    hide(aDelay = 0) {
        this.item.animationLayer.properties.alpha.animateValue(0, 0.3, aDelay);
        this.item.animationLayer.properties.scale.animateValue(0, 0.3, aDelay);
    }

    update(aTime, aDelta) {

    }
}